import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { Svg, Path } from 'react-native-svg';

interface PasswordValidation {
  checks: {
    minLength: boolean;
    hasUppercase: boolean;
    hasLowercase: boolean;
    hasNumber: boolean;
  };
}

interface PasswordRequirementsProps {
  validation: PasswordValidation;
}

export default function PasswordRequirements({ validation }: PasswordRequirementsProps) {
  return (
    <View style={styles.requirementsContainer}>
      <Text style={styles.requirementsTitle}>Sua senha deve ter:</Text>

      <View style={styles.requirementsList}>
        <View style={styles.requirementItem}>
          <View style={[
            styles.checkbox,
            validation.checks.minLength && styles.checkboxActive
          ]}>
            {validation.checks.minLength && (
              <Svg width="8" height="8" viewBox="0 0 8 8" fill="none">
                <Path 
                  d="M6.33268 2.396L3.12435 5.60433L1.66602 4.146" 
                  stroke="white" 
                  strokeWidth="2" 
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                />
              </Svg>
            )}
          </View>
          <Text style={styles.requirementText}>Mínimo 8 letras</Text>
        </View>

        <View style={styles.requirementItem}>
          <View style={[
            styles.checkbox,
            validation.checks.hasUppercase && styles.checkboxActive
          ]}>
            {validation.checks.hasUppercase && (
              <Svg width="8" height="8" viewBox="0 0 8 8" fill="none">
                <Path 
                  d="M6.33268 2.396L3.12435 5.60433L1.66602 4.146" 
                  stroke="white" 
                  strokeWidth="2" 
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                />
              </Svg>
            )}
          </View>
          <Text style={styles.requirementText}>Uma letra maiúscula</Text>
        </View>

        <View style={styles.requirementItem}>
          <View style={[
            styles.checkbox,
            validation.checks.hasLowercase && styles.checkboxActive
          ]}>
            {validation.checks.hasLowercase && (
              <Svg width="8" height="8" viewBox="0 0 8 8" fill="none">
                <Path 
                  d="M6.33268 2.396L3.12435 5.60433L1.66602 4.146" 
                  stroke="white" 
                  strokeWidth="2" 
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                />
              </Svg>
            )}
          </View>
          <Text style={styles.requirementText}>Uma letra minúscula</Text>
        </View>

        <View style={styles.requirementItem}>
          <View style={[
            styles.checkbox,
            validation.checks.hasNumber && styles.checkboxActive
          ]}>
            {validation.checks.hasNumber && (
              <Svg width="8" height="8" viewBox="0 0 8 8" fill="none">
                <Path 
                  d="M6.33268 2.396L3.12435 5.60433L1.66602 4.146" 
                  stroke="white" 
                  strokeWidth="2" 
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                />
              </Svg>
            )}
          </View>
          <Text style={styles.requirementText}>Um número</Text>
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  requirementsContainer: {
    padding: 24,
    alignItems: 'flex-start',
    gap: 20,
    borderWidth: 1,
    borderColor: '#F0EEE4',
    backgroundColor: '#F9F8F3',
    borderRadius: 16,
    flexDirection: 'column',
    width: '100%',
  },
  requirementsTitle: {
    color: '#000000',
    fontFamily: 'Inter_700Bold',
    fontSize: 14,
    lineHeight: 14,
  },
  requirementsList: {
    alignItems: 'flex-start',
    gap: 8,
    flexDirection: 'column',
    width: '100%',
  },
  requirementItem: {
    alignItems: 'center',
    gap: 8,
    width: '100%',
    height: 24,
    flexDirection: 'row',
  },
  checkbox: {
    aspectRatio: 1,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: '#7E7D75',
    backgroundColor: '#FFFFFF',
    width: 16,
    height: 16,
    alignItems: 'center',
    justifyContent: 'center',
  },
  checkboxActive: {
    backgroundColor: '#015480',
    borderColor: '#015480',
  },
  requirementText: {
    color: '#000000',
    fontFamily: 'Inter_400Regular',
    fontSize: 14,
    lineHeight: 14,
  },
});